import { useEffect } from 'react'
import { useGameState } from './useGameState'

const ARROWS: Record<string, [number, number]> = {
  ArrowUp: [-1, 0],
  ArrowDown: [1, 0],
  ArrowLeft: [0, -1],
  ArrowRight: [0, 1],
}

/** Keyboard play: type letters at the cursor, arrows to move, Enter to play. */
export function useKeyboard(enabled: boolean) {
  useEffect(() => {
    if (!enabled) return
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.ctrlKey || e.metaKey || e.altKey) return
      const target = e.target as HTMLElement | null
      // Leave Enter/Space alone on ordinary controls so they stay keyboard-accessible.
      const onControl = target?.closest('button, a, input, textarea, select') && !target.closest('[aria-label="Game board"]')
      const game = useGameState.getState()
      if (game.record?.finished) return

      if (/^[a-zA-Z]$/.test(e.key)) {
        game.typeLetter(e.key.toUpperCase())
      } else if (e.key in ARROWS) {
        game.moveCursor(...ARROWS[e.key])
      } else if (e.key === 'Backspace') {
        game.backspace()
      } else if (e.key === 'Escape') {
        game.recallAll()
      } else if (e.key === 'Enter' && !onControl) {
        game.submit()
      } else if (e.key === ' ' && !onControl) {
        game.toggleDirection()
      } else {
        return
      }
      e.preventDefault()
    }
    window.addEventListener('keydown', onKeyDown)
    return () => window.removeEventListener('keydown', onKeyDown)
  }, [enabled])
}
